const SPACES = /\s+/g;
const NON_WORD_CHARACTERS = /[^\w-]+/g;
const MULTIPLE_DASHES = /--+/g;
const LEADING_DASH = /^-+/;
const TRAILING_DASH = /-+$/;
const TRAILING_SLASH = /\/+$/;
const LOWERCASE_LETTERS = /-([a-z])/g;

export default {
  LEADING_DASH,
  LOWERCASE_LETTERS,
  MULTIPLE_DASHES,
  NON_WORD_CHARACTERS,
  SPACES,
  TRAILING_DASH,
  TRAILING_SLASH,
};
